import custom from './custom';
import customImage from './customImage';
import invite from './invite';
import promoteJob from './promoteJob';
import promoteJobs from './promoteJobs';
import promoteContent from './promoteContent';
import promoteContentShares from './promoteContentShares';
import leaderboardIndividual from './leaderboardIndividual';
import leaderboardOverall from './leaderboardOverall';
import collectiveGoal from './collectiveGoal';
import gamification from './gamification';

import inMobiCustom from './inMobi/custom';
import inMobiInvite from './inMobi/invite';
import inMobiPromoteJob from './inMobi/promoteJob';
import inMobiJobTable from './inMobi/jobTable';
import inMobiPromoteContent from './inMobi/promoteContent';
import inMobiLeaderboardIndividual from './inMobi/leaderboardIndividual';
import inMobiLeaderboardOverall from './inMobi/leaderboardOverall';
import inMobiCollectiveGoal from './inMobi/collectiveGoal';

export default client => {
  if (client === 'inMobi') {
    return [
      inMobiCustom,
      inMobiInvite,
      inMobiPromoteJob,
      inMobiJobTable,
      inMobiPromoteContent,
      inMobiLeaderboardIndividual,
      inMobiLeaderboardOverall,
      inMobiCollectiveGoal,
    ];
  }
  return [
    custom,
    customImage,
    invite,
    promoteJob,
    promoteJobs,
    promoteContent,
    promoteContentShares,
    leaderboardIndividual,
    leaderboardOverall,
    collectiveGoal,
    gamification,
  ];
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/emails/index.js